import { toDollars } from "./toDollars";

const formatCentsToUSD = (value: number | string) =>
  new Intl.NumberFormat("en-US", { currency: "USD", style: "currency" }).format(
    +toDollars(value)
  );

export default formatCentsToUSD;
